import AdvMarker from "@/components/Maps/maps-advanced-marker";
import Marker from "@/components/Maps/maps-marker";
import MapRoute from "@/components/Maps/maps-route";
import _ from "lodash";

import Maps from "@/components/Maps/Maps.vue";
import { DeferredReady } from "@/helpers/Maps/deferredReady";
import MountableMixin from "@/helpers/Maps/mountableMixin";

// export everything
export {
    Maps,
    Marker,
    MountableMixin
};

export function install(Vue, options) {
    options = _.defaults(options, {
        installComponents: true
    });

    Vue.use(DeferredReady);

    const defaultResizeBus = new Vue();
    Vue.$gmapDefaultResizeBus = defaultResizeBus;
    Vue.mixin({
        created() {
            this.$gmapDefaultResizeBus = defaultResizeBus;
        }
    });

    if (options.installComponents) {
        Vue.component("Maps", Maps);
        Vue.component("MapMarker", Marker);
        Vue.component("MapAdvMarker", AdvMarker);
        Vue.component("MapRoute", MapRoute);
    }
}
